// extracted by mini-css-extract-plugin
module.exports = {"root":"selection-card-control_root__MDvmv","vertical":"selection-card-control_vertical___0PZi","horizontal":"selection-card-control_horizontal___TbSH"};